import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import Header from "../../../components/Header";
import api from "../../../connector/api";

const StudentListLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [view, setView] = useState("dashboard");
  const [permissions, setPermissions] = useState([]);
  const [user, setUser] = useState({ first_name: "Achmad", last_name: "Hakim", email: "achmadhakim@gmail.com" });
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const storedPerms = sessionStorage.getItem("permissions");
    const storedUser = sessionStorage.getItem("user");

    if (storedPerms) {
      try {
        setPermissions(JSON.parse(storedPerms));
      } catch (err) {
        console.error("Failed to parse permissions:", err);
      }
    }

    if (storedUser) {
      try {
        const userObj = JSON.parse(storedUser);
        setUser({
          first_name: userObj.first_name || "Achmad",
          last_name: userObj.last_name || "Hakim",
          username: userObj.username || "achmadhakim",
          email: userObj.email || "achmadhakim@gmail.com",
        });
      } catch (err) {
        console.error("Failed to parse user session:", err);
      }
    }
  }, []);

  useEffect(() => {
    if (!currentUser) {
      const fetchUserData = async () => {
        try {
          const response = await api.get("accounts/me/");
          if (response.data && response.data.user) {
            setCurrentUser({
              ...response.data.user,
              permissions: response.data.permissions || [],
            });
          }
        } catch (error) {
          console.error("Could not load user data from backend API:", error);
        }
      };
      fetchUserData();
    }
  }, [currentUser]);

  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = "/login";
  };

  return (
    <div className="flex h-screen overflow-y-hidden w-screen overflow-hidden bg-slate-50 font-sans text-slate-800">
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        permissions={permissions}
        user={user}
        handleLogout={handleLogout}
        onOpenChangePassword={() => setIsModalOpen(true)}
      />

      <div className="flex flex-col flex-1 min-w-0 overflow-hidden relative h-full">
        <Header
          currentUser={currentUser}
          currentView={view}
          setView={setView}
          onLogout={handleLogout}
          onToggleSidebar={() => setSidebarOpen((prev) => !prev)}
        />

        <main className="flex-1 overflow-y-auto bg-slate-50/50 custom-scroll">
          {children || <Outlet />}
        </main>
      </div>
    </div>
  );
};

export default StudentListLayout;